module.exports = "/fonts/herculift.ttf?ee42e770a6767af2ba3fab65ee604fd7";